var Contract = (function () {

  function deleteObjects(ids) {
    return $.ajax({
      url: Url.action('api/contracts'),
      type: 'DELETE',
      data: { ids: ids }
    })
    .done(() => {
        _refreshTable(true, ids);
      });
  };

  function _show(id) {
    var modal = ModalConductor.activate(ContractViewModal, id,
        (contractId) => {
          deleteObjects([contractId]).done(() => {
            modal.close();
          });
        })
      .on('closed', (modalResult) => _refreshTable());
  }

  function _delete(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      deleteObjects(ids);
    }
  }

  function _add() {
    ModalConductor.activate(ContractEdtiModal)
     .on('closed', (modalResult) => {
       if (modalResult.ok) {
         _refreshTable();
       }
     });
  }

    function _refreshTable(resetChecked, idsForDeselect) {
        var table = $('#ContractListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, false, idsForDeselect);
    };

  return {
    show: _show,
    del: _delete,
    add: _add
  };
}())
